/**
 *
 * Asynchronously loads the component for ReserveUsernameForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const IntrosGotoSlack = lazyLoad(
  () => import('./index'),
  module => module.IntrosGotoSlack,
);
